(function(w, d, __tnt) {

    // foreach polyfill for ie11
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    var eEdition = __tnt.eedition || (__tnt.eedition = {}),
        eeData, eeUuid, eeLength, eeHighlight,
        bottomBarMenu, mainMenu, sidebarMenu,
        nextArrow, prevArrow,
        eeCarousel, eeStage, slideIndex,
        isMobile, zoomLevel,
        currentPageUuids = [],
        pageViewLink,
        viewMode;

    eEdition.app = {

        _init: function() {
            if (!eEdition.utilities.assetData()) return false;

            // Set Global Vars
            eeLength = Object.keys(eeData).length;

            eeStage = d.getElementById('eedition-stage');
            bottomBarMenu = d.getElementById('eedition-bottombar');
            mainMenu = d.getElementById('eedition-mainmenu');
            sidebarMenu = d.getElementById('eedition-sidebar');

            nextArrow = d.querySelector('.eedition-arrow.next');
            prevArrow = d.querySelector('.eedition-arrow.prev');

            isMobile = (w.innerWidth <= 768) ? true : false;
            zoomLevel = eEdition.utilities.minimumZoomLevel();

            viewMode = (d.getElementById('eedition-wrapper').classList.contains('view-page')) ? 'page' : 'text';

            // Subscription Check
            if (eEdition.subscription.hasServices()) {
                w.addEventListener('tnt-user-status', function(e) {
                    if (e.hasAccess) eEdition.app.loadApps();
                });
            } else {
                eEdition.app.loadApps();
            }
            
            // Sidebar sign in
            if (__tnt.user.loggedIn) {
                document.getElementById('user-profile-login').classList.add('hidden');
                document.getElementById('user-profile-logout').classList.remove('hidden');
            }
        },

        loadApps: function() {
            // Load carousel, menus, and navigation
            if (viewMode === 'page') {
                eEdition.pageview.carousel._init();
                eEdition.pageview.navigation._init();
            } else if (viewMode === 'text') {
                eEdition.textview.navigation._init();
                eEdition.textview.print._init();
                eEdition.textview.toc.getActiveAsset();
                eEdition.textview.thumbnail.setup();
            }

            eEdition.menu._init();

            // Resize Event Listener
            w.addEventListener('resize', function() {
                eEdition.app.resize(false);
            });
        },

        resize: function(rebuild) {
            if (viewMode == 'page') {
                // Rebuild Carousel if viewport changes
                var carouselSlidePos = null;

                if ((isMobile && w.innerWidth > 768) || (!isMobile && w.innerWidth <= 768) || rebuild) {
                    // Reset Global Var
                    isMobile = (w.innerWidth <= 768) ? true : false;

                    // Delete Carousel
                    eeStage.removeChild(eeCarousel);

                    // Re-initialize Carousel
                    eEdition.pageview.carousel._init();

                    // Set Carousel slide position to current uuid
                    carouselSlidePos = eeUuid;

                    // Reset Menu
                    eEdition.menu.update();
                }

                // Stage
                if (bottomBarMenu) {
                    eeStage.style.height = (bottomBarMenu.classList.contains('active')) ? 'calc(100vh - ' + (mainMenu.offsetHeight + bottomBarMenu.offsetHeight) + 'px)' :  'calc(100vh - ' + mainMenu.offsetHeight + 'px)';
                }

                // Page Menu
                if (bottomBarMenu) {
                    bottomBarMenu.querySelector('.thumbnails').style.width = w.innerWidth + 'px';
                }

                // Carousel image zoom
                zoomLevel = eEdition.utilities.minimumZoomLevel();
                eEdition.pageview.image.zoom('reset');

                // Carousel slide postion
                eEdition.pageview.carousel.navigate(carouselSlidePos, 'reset');
            } else {
                eEdition.textview.navigation.arrowOffset();
            }
        }

    };

    eEdition.menu = {

        _init: function() {

            // Initial Menu Update
            if (viewMode == 'page') {
                eEdition.menu.update();
            }

            // Event listner for menu icon
            mainMenu.querySelector('#eedition-menu-icon').addEventListener('click', function() {
                eEdition.menu.main();
            });

            var viewSwitch = mainMenu.querySelector('.eedition-switch input');
            viewSwitch.addEventListener('change', function(e) {
                if (typeof pageViewLink !== 'undefined') {
                    if (pageViewLink.indexOf('/preview/') != -1) {
                        window.location = pageViewLink;
                    } else {
                        window.location = __tnt.scrubUrl(pageViewLink);
                    }
                }
            });

            eEdition.menu.showViewSwitch();

            // Facing Pages Switch
            if (viewMode == 'page') {
                var settingsSwitch = sidebarMenu.querySelector('.setting-switch'),
                    switchSlider = settingsSwitch.querySelector('.setting-slider'),
                    switchInput = settingsSwitch.querySelector('input');

                if (localStorage.getItem('__tnt.eedition.facingPages') === '0') switchInput.checked = false;
                switchSlider.addEventListener('click', function() {                
                    setTimeout(function() {
                        if (switchInput.checked) {
                            if (localStorage.getItem('__tnt.eedition.facingPages')) localStorage.removeItem('__tnt.eedition.facingPages');
                        } else {
                            localStorage.setItem('__tnt.eedition.facingPages', '0');
                        }
                        eEdition.menu.reset();
                        eEdition.app.resize(true);
                    }, 200);
                });
            }

            // Sidebar menu icon
            Array.from(sidebarMenu.querySelectorAll('.icon')).forEach(function(el) {
                el.addEventListener('click', function() {
                    eEdition.menu.side(el.dataset.menu);
                });
            });

            // Bottom menu icon
            if (viewMode == 'page') {
                bottomBarMenu.querySelector('.menu-btn').addEventListener('click', function() {
                    eEdition.menu.bottom();
                    eEdition.app.resize(false);
                });
            }

            // Download full eEdition
            var editionDownload = sidebarMenu.querySelector('.edition-download');
            editionDownload.addEventListener('click', function(e) {
                eEdition.utilities.gtmDownloadEvent('full download', e.target.textContent.trim(), e.target.dataset.url);
                eEdition.menu.download(editionDownload.dataset.url);
            });

            // Content blocker
            d.getElementById('eedition-blocker').addEventListener('click', function() {
                eEdition.menu.reset();
            });

            // Bottom menu navigation/update/preload
            if (viewMode == 'page') {
                Array.from(bottomBarMenu.querySelectorAll('.section-link')).forEach(function(el) {
                    el.addEventListener('click', function() {
                        eEdition.pageview.navigation.navigate(el.dataset.eeditionUuid);
                    });
                });
                Array.from(bottomBarMenu.querySelectorAll('.thumbnail-link')).forEach(function(el) {
                    el.addEventListener('tap', function() {
                        eEdition.pageview.navigation.navigate(el.dataset.eeditionUuid);
                    });
                });
            }

            // Logout form submission
            var logoutLink = sidebarMenu.querySelector('#user-profile-logout');
            if (logoutLink) {
                logoutLink.addEventListener('click', function() {
                    sidebarMenu.querySelector('#tncms-logout-form').submit();
                });
            }

            // Zoom buttons
            if (viewMode == 'page') {
                Array.from(mainMenu.querySelectorAll('.zoom')).forEach(function(el) {
                    el.addEventListener('click', function() {
                        eEdition.pageview.image.zoom(el.dataset.direction);
                    });
                });

                // Pages Scroller
                var scroller = bottomBarMenu.querySelector('.thumbnail-scroller'),
                    thumbnails = bottomBarMenu.querySelector('.thumbnails'),
                    iScroll;

                scroller.style.width = (scroller.offsetWidth + 10) + 'px';
                thumbnails.style.width = w.innerWidth + 'px';
                iScroll = new IScroll(thumbnails, {scrollX: true, scrollY: false, tap: true});
            }
        },

        // Bottom menu
        bottom: function() {
            if (bottomBarMenu.classList.contains('active')) {
                bottomBarMenu.classList.remove('active');
            } else {
                bottomBarMenu.classList.add('active');
            }
        },

        // Download full eEdition
        download: function(url) {
            var attempts = 0;
            getPDF(url);
            function getPDF(url) {
                fetch(url)
                    .then(
                        function(response) {
                            if (response.status !== 200) {
                                __tnt.log('There was a problem with the download. Status Code: ' + response.status);
                            } else {
                                response.json().then(function(data) {
                                    if (data.status === 'complete') {
                                        setTimeout(function(){
                                            window.location.href = data.file;
                                        }, 3000);
                                    } else if (data.status === 'running') {
                                        __tnt.log('File is currently being generated.');
                                        attempts++;
                                        if (attempts >= 10) {
                                            __tnt.log('Too many download attempts.');
                                            return;
                                        }
                                        setTimeout(function(){
                                            getPDF(url);
                                        }, 1000);
                                    }
                                });
                            }
                        }
                  )
                  .catch(function(e) {
                    __tnt.log('Fetch Error:', e);
                  });
            }
        },

        // Main menu
        main: function() {
            if (mainMenu.classList.contains('active') || sidebarMenu.classList.contains('active')) {
                eEdition.menu.reset();
            } else {
                if (bottomBarMenu && bottomBarMenu.classList.contains('active')) eEdition.menu.reset();
                [mainMenu, sidebarMenu].forEach(function(el) {
                    el.classList.add('active');
                });
            }
        },

        // Reset menu
        reset: function() {
            [bottomBarMenu, mainMenu, sidebarMenu].forEach(function(el) {
                if (el) {
                    el.classList.remove('active', 'editions', 'downloads', 'publications', 'settings');
                    if (viewMode == 'page') {
                        eEdition.app.resize(false);
                    }
                }
            });
        },

        // View switcher
        showViewSwitch: function() {
            if (viewMode == 'page') {
                var hasArticleSegment = false;
                var articleSegmentUrl;
                for (var i = 0; i < currentPageUuids.length; i++) {
                    var uuid = currentPageUuids[i];
                    if (eeData[uuid].segments) {
                        for (var region in eeData[uuid].segmentRegions) {
                            if (eeData[uuid].segmentRegions[region].type === 'article') {
                                hasArticleSegment = true;
                                articleSegmentUrl = eeData[uuid].segmentRegions[region].link;
                                break;
                            }
                        }
                    }
                    if (typeof articleSegmentUrl !== 'undefined') break;
                }
                if (hasArticleSegment) {
                    d.querySelector('.eedition-switch').classList.remove('hidden');
                    pageViewLink = articleSegmentUrl;
                } else {
                    d.querySelector('.eedition-switch').classList.add('hidden');
                    pageViewLink = undefined;
                }
            } else {
                d.querySelector('.eedition-switch').classList.remove('hidden');
                pageViewLink = eeData[eeUuid].url;
            }
        },

        // Side Menu
        side: function(selection) {
            if (!mainMenu.classList.contains(selection) || !sidebarMenu.classList.contains(selection)) {
                [mainMenu, sidebarMenu].forEach(function(el) {
                    el.classList.remove('editions', 'downloads', 'publications', 'settings');
                    el.classList.add(selection);
                });
            } else {
                [mainMenu, sidebarMenu].forEach(function(el) {
                    el.classList.remove('editions', 'downloads', 'publications', 'settings');
                });
            }
        },

        // Update menu
        update: function(uuid) {
            var pageUuid = (uuid) ? uuid : eeUuid,
                pageSection = eeData[pageUuid].section,
                sectionLinks = Array.from(bottomBarMenu.querySelectorAll('.section-container .section-link')),
                thumbnailLinks = Array.from(bottomBarMenu.querySelectorAll('.thumbnail-container .thumbnail-link'));

            // Bottom Menu Display
            bottomBarMenu.style.bottom = -Math.abs(bottomBarMenu.offsetHeight) + 'px';
            setTimeout(function() {
                bottomBarMenu.style.visibility = 'visible';
            }, 500);

            // Clear selections
            thumbnailLinks.forEach(function(el) {
                el.classList.remove('selected-section', 'selected-thumbnail');
            });
            sectionLinks.forEach(function(el) {
                el.classList.remove('selected-section', 'selected-thumbnail');
            });

            // Loop through thumbnails
            thumbnailLinks.forEach(function(el) {

                // Highlight selected page
                if (eeData[el.dataset.eeditionUuid].slideIndex == slideIndex) el.classList.add('selected-thumbnail');

                // Highlight page numbers for the selected section
                if (eeData[el.dataset.eeditionUuid].section == pageSection) el.classList.add('selected-section');
            });

            // Loop through sections
            sectionLinks.forEach(function(el) {

                // Highlight sections
                if (eeData[el.dataset.eeditionUuid].section == pageSection) el.classList.add('selected-section');
            });
        }

    };

    eEdition.pageview = {

        carousel: {
            _init: function() {
                var carousel = d.createElement('div'),
                    itemArray = [],
                    itemIndex = 0;

                Object.keys(eeData).forEach(function(item, index) {
                    if (index === 0 || isMobile || localStorage.getItem('__tnt.eedition.facingPages') === '0') {
                        itemArray.push(item);
                        carousel.appendChild(eEdition.pageview.carousel.item(itemArray, itemIndex));
                        eeData[item].slideIndex = itemIndex;
                        itemArray = [];
                        itemIndex++;
                    } else {
                        itemArray.push(item);
                        eeData[item].slideIndex = itemIndex;
                        if (itemArray.length === 2) {
                            carousel.appendChild(eEdition.pageview.carousel.item(itemArray, itemIndex));
                            itemArray = [];
                            itemIndex++;
                        }
                    }
                });

                // This item should be the back cover.
                if (itemArray.length > 0) carousel.appendChild(eEdition.pageview.carousel.item(itemArray, itemIndex));

                carousel.id = 'eedition-carousel';
                eeStage.insertBefore(carousel, prevArrow);
                eeCarousel = d.querySelector('#eedition-carousel');

                // Navigate to the correct page.
                eEdition.pageview.carousel.navigate(eeUuid);
            },

            item: function(items, index) {
                var slide = d.createElement('div'),
                    pageContainer = d.createElement('div'),
                    pageHeight = (isMobile) ? Math.round(w.innerWidth * (eeData[items[0]].imageHeight / eeData[items[0]].imageWidth)) : zoomLevel;

                slide.classList.add('slide');
                slide.dataset.index = index;
                slide.style.left = index + '00%';

                pageContainer.classList.add('pages');
                pageContainer.style.height = pageHeight + 'px';
                if (isMobile) {
                    pageContainer.style.width = w.innerWidth + 'px';
                } else {
                    var contWidth = 0;
                    items.forEach(function(item) {
                        contWidth += Math.round(zoomLevel * eeData[item].aspectRatio);
                    });
                    pageContainer.style.width = contWidth + 'px';
                }

                items.forEach(function(item) {
                    var img = d.createElement('img'),
                        loader = d.createElement('i'),
                        page = d.createElement('div'),
                        pageContent = d.createElement('div'),
                        pageWidth = (isMobile) ? (w.innerWidth) : Math.round(zoomLevel * eeData[item].aspectRatio);

                    loader.classList.add('fas', 'tnt-spinner', 'tnt-spin', 'tnt-4x', 'loader', 'hidden-print');

                    page.classList.add('page');
                    page.style.height = pageHeight + 'px';
                    page.style.width = pageWidth + 'px';
                    page.dataset.uuid = item;
                    page.appendChild(loader);

                    pageContent.classList.add('page-content');

                    img.alt = eeData[item].title;
                    img.dataset.src = eeData[item].image;
                    img.style.height = pageHeight + 'px';
                    img.style.width = pageWidth + 'px';

                    // Append canvas if item includes segments
                    if (eeData[item].segments && Object.keys(eeData[item].segmentRegions).length > 0) {
                        img.setAttribute('usemap', '#map-' + item);
                        pageContent.appendChild(img);
                        eEdition.pageview.imageMap.segments(pageContent, item, pageHeight, pageWidth, true);
                    } else {
                        pageContent.appendChild(img);
                    }

                    page.appendChild(pageContent);
                    pageContainer.appendChild(page);
                });

                slide.appendChild(pageContainer);

                return slide;
            },

            navigate: function(uuid, direction) {
                var carouselPosition = 0;

                if (direction) {
                    if (direction != 'reset') slideIndex = (direction == 'next') ? slideIndex + 1 : slideIndex - 1;
                } else if (uuid) {
                    slideIndex = eeData[uuid].slideIndex;
                }

                eEdition.pageview.image.load(slideIndex);
                eEdition.pageview.image.zoom('reset');

                var pages = eeCarousel.querySelectorAll('.slide')[slideIndex].querySelectorAll('.page');

                currentPageUuids = [];
                pages.forEach(function(page) {
                    currentPageUuids.push(page.dataset.uuid);
                });

                eEdition.menu.showViewSwitch();

                if (slideIndex !== 0) carouselPosition = slideIndex * w.innerWidth;
                eeCarousel.style.transform = 'translate3d(' + -carouselPosition + 'px, 0, 0)';
            }
        },

        image: {
            flag: function(slide, pages) {
                // Flag pages that have already been rendered
                var pagesRendered = true;

                for (var i = 0; i < pages.length; i++) {
                    if (!pages[i].querySelector('.page-content').classList.contains('visible')) {
                        pagesRendered = false;
                        break;
                    }
                }

                if (pagesRendered) slide.classList.add('rendered');
            },

            load: function(index) {
                var slide = eeCarousel.querySelectorAll('.slide')[index],
                    pages = slide.querySelectorAll('.pages .page');

                pages.forEach(function(page) {
                    var imgTag = page.querySelector('img');

                    if (!imgTag.src && imgTag.dataset.src) {
                        var image = new Image(),
                            content = page.querySelector('.page-content');

                        image.onload = function() {
                            eEdition.pageview.image.reveal(page, content, imgTag);
                            eEdition.pageview.image.flag(slide, pages);
                            eEdition.pageview.image.preload(index);
                        };

                        image.src = imgTag.dataset.src;
                    }
                });
            },

            preload: function(index) {
                var slide = eeCarousel.querySelectorAll('.slide')[index + 1];

                if (slide && !slide.classList.contains('rendered')) {
                    var pages = slide.querySelectorAll('.pages .page');

                    pages.forEach(function(page) {
                        var imgTag = page.querySelector('img');

                        if (!imgTag.src && imgTag.dataset.src) {
                            var image = new Image();

                            image.src = imgTag.dataset.src;
                        }
                    });
                }
            },

            reveal: function(page, content, img) {
                // Timeout to avoid race condition with font-awesome
                setTimeout(function(){
                    var loader = page.querySelector('.loader');
                    loader.classList.add('hidden');
                }, 100);

                img.src = img.dataset.src;
                //img.removeAttribute('data-src'); Keeping the dataset until the undefined image bug is resolved.
                content.classList.add('visible');
            },

            zoom: function(direction) {
                var currentHeight, newHeight,
                    slide = eeCarousel.querySelectorAll('.slide')[slideIndex],
                    pageContainer = slide.querySelector('.pages'),
                    pages = pageContainer.querySelectorAll('.page');

                newHeight = currentHeight = pageContainer.offsetHeight;

                if (direction === 'in' && currentHeight < 1950) {
                    newHeight = currentHeight + 100;
                } else if (direction === 'out' && currentHeight > 350) {
                    newHeight = currentHeight - 100;
                } else if (direction === 'reset') {
                    newHeight = (isMobile) ? Math.round(w.innerWidth * (eeData[pages[0].dataset.uuid].imageHeight / eeData[pages[0].dataset.uuid].imageWidth)) : zoomLevel;
                }

                if (currentHeight !== newHeight) {
                    pages.forEach(function(page) {
                        var img = page.querySelector('img'),
                            canvas = page.querySelector('canvas'),
                            pageHeight = newHeight,
                            pageWidth = (isMobile) ? w.innerWidth : Math.round(newHeight * eeData[page.dataset.uuid].aspectRatio);

                        page.style.height = pageHeight + 'px';
                        page.style.width = pageWidth + 'px';

                        img.style.height = pageHeight + 'px';
                        img.style.width = pageWidth + 'px';

                        if (canvas) eEdition.pageview.imageMap.segments(page, page.dataset.uuid, pageHeight, pageWidth, true);
                    });

                    pageContainer.style.height = newHeight + 'px';
                    if (isMobile) {
                        pageContainer.style.width = w.innerWidth + 'px';
                    } else {
                        var contWidth = 0;
                        pages.forEach(function(page) {
                            contWidth += Math.round(newHeight * eeData[page.dataset.uuid].aspectRatio);
                        });
                        pageContainer.style.width = contWidth + 'px';
                    }
                }
                setTimeout(function() {
                    eEdition.pageview.navigation.arrowOffset();
                }, 500);
            }
        },

        imageMap: {
            plotCoords: function(type, coords, region, scale) {
                var area = d.createElement('area'),
                    coordsArray = [
                        Math.round(coords.left * scale),
                        Math.round(coords.top * scale),
                        Math.round(coords.right * scale),
                        Math.round(coords.bottom * scale)
                    ],
                    extLink = true,
                    pageUuid;

                area.shape = 'rect';
                area.coords = coordsArray.join(',');

                if (type === 'link') {
                    if (coords.link.indexOf('page_') !== -1) {
                        pageUuid = coords.link.substring(coords.link.lastIndexOf('page_') + 5, coords.link.lastIndexOf('.html'));
                        if (pageUuid.length > 0 && eeData[pageUuid]) extLink = false;
                    }

                    if (extLink) {
                        area.href= coords.link;
                        area.target = '_blank';
                        area.rel = 'noopener';
                    } else {
                        area.addEventListener('click', function() {
                            eEdition.pageview.navigation.navigate(pageUuid);
                        });
                    }
                } else if (type === 'image') {
                    area.classList.add('area-' + region);
                    area.addEventListener('click', function() {
                        // jQuery required for Bootstrap modal method
                        $('#modal-' + region).modal('show');
                    });
                    area.addEventListener('mouseenter', function() {
                        area.classList.add('selected');
                        eEdition.pageview.imageMap.redraw();
                    });
                    area.addEventListener('mouseout', function() {
                        area.classList.remove('selected');
                        eEdition.pageview.imageMap.redraw();
                    });
                } else if (type === 'article') {
                    area.href = __tnt.scrubUrl(coords.link);
                }

                return area;
            },

            redraw: function() {
                var slide = eeCarousel.querySelectorAll('.slide')[slideIndex],
                    pageContainer = slide.querySelector('.pages'),
                    pages = pageContainer.querySelectorAll('.page'),
                    pageHeight = pageContainer.offsetHeight;

                pages.forEach(function(page) {
                    var pageWidth = (isMobile) ? w.innerWidth : Math.round(pageHeight * eeData[page.dataset.uuid].aspectRatio);
                    eEdition.pageview.imageMap.segments(page, page.dataset.uuid, pageHeight, pageWidth, false);
                });
            },

            segments: function(page, item, pageHeight, pageWidth, createMap) {
                var canvas = (page.querySelector('canvas')) ? page.querySelector('canvas') : d.createElement('canvas'),
                    ctx = canvas.getContext('2d'),
                    map = (page.querySelector('map')) ? page.querySelector('map') : d.createElement('map'),
                    scale = pageHeight / eeData[item].imageHeight;

                canvas.height = pageHeight;
                canvas.width = pageWidth;

                ctx.fillStyle = (eeHighlight) ? eeHighlight : '#000000';
                ctx.globalAlpha = 0.3;
                ctx.scale(scale, scale);

                if (createMap) {
                    map.innerHTML = '';
                    map.name = 'map-' + item;
                }

                Object.keys(eeData[item].segmentRegions).forEach(function(region) {
                    var segmentRegion = eeData[item].segmentRegions[region],
                        width = segmentRegion.right - segmentRegion.left,
                        height = segmentRegion.bottom - segmentRegion.top;

                    //if (segmentRegion.type === 'image') {
                    if (segmentRegion.type === 'image' || segmentRegion.type === 'article') {
                        if (map.querySelector('area.selected.area-' + region)) {
                            ctx.fillRect(segmentRegion.left, segmentRegion.top, width, height);
                        } else {
                            var length = (width <= height) ? Math.round(width / 2) : Math.round(height / 2);

                            ctx.beginPath();
                            ctx.moveTo((segmentRegion.left + width - length), segmentRegion.top);
                            ctx.lineTo((segmentRegion.left + width), segmentRegion.top);
                            ctx.lineTo((segmentRegion.left + width), (segmentRegion.top + length));
                            ctx.closePath();
                            ctx.fill();
                        }
                        if (createMap) map.appendChild(eEdition.pageview.imageMap.plotCoords(segmentRegion.type, eeData[item].segmentRegions[region], region, scale));
                    } else if (segmentRegion.type === 'link') {
                        ctx.fillRect(segmentRegion.left, segmentRegion.top, width, height);
                        if (createMap) map.appendChild(eEdition.pageview.imageMap.plotCoords('link', eeData[item].segmentRegions[region], region, scale));
                    } else if (segmentRegion.type === 'video') {
                        eEdition.pageview.imageMap.video(page, region, eeData[item].segmentRegions[region], scale, width, height);
                    }

                    page.appendChild(canvas);
                    if (createMap) page.appendChild(map);
                });
            },

            video: function(page, region, coords, scale, width, height) {
                var df, iframe, video, videoEl,
                    videoLoaded = (page.querySelector('.video-' + region)) ? true : false;

                if (videoLoaded) {
                    video = page.querySelector('.video-' + region);
                    iframe = video.querySelector('iframe');
                    videoEl = video.querySelector('video');
                } else {
                    df = __tnt.template(d.getElementById('video-' + region));
                    iframe = df.querySelector('iframe');
                    video = d.createElement('div');
                    video.classList.add('video', 'video-' + region);
                    videoEl = df.querySelector('video');
                }

                if (iframe) {
                    iframe.width = Math.round(width * scale);
                    iframe.height = Math.round(height * scale);
                }

                if (videoEl) {
                    videoEl.width = Math.round(width * scale);
                    videoEl.height = Math.round(height * scale);
                }

                video.style.top = Math.round(coords.top * scale) + 'px';
                video.style.left = Math.round(coords.left * scale) + 'px';
                video.style.height = Math.round(height * scale) + 'px';
                video.style.width = Math.round(width * scale) + 'px';

                if (!videoLoaded) {
                    video.appendChild(df);
                    page.appendChild(video);
                }
            }
        },

        navigation: {
            _init: function() {
                var direction;

                [nextArrow, prevArrow].forEach(function(el) {
                    el.addEventListener('click', function() {
                        direction = (el.classList.contains('next')) ? 'next' : 'prev';
                        eEdition.pageview.navigation.navigate(el.dataset.eeditionUuid, direction);
                    });
                });
                eEdition.pageview.navigation.update(eeUuid);
                eEdition.pageview.navigation.arrowDisplay();
            },

            arrowDisplay: function() {
                if (Object.keys(eeData)[0] == eeUuid) {
                    if (nextArrow.classList.contains('hidden')) nextArrow.classList.remove('hidden');
                    if (!prevArrow.classList.contains('hidden')) prevArrow.classList.add('hidden');
                } else if (eeData[Object.keys(eeData)[eeLength - 1]].slideIndex == slideIndex) {
                    if (!nextArrow.classList.contains('hidden')) nextArrow.classList.add('hidden');
                    if (prevArrow.classList.contains('hidden')) prevArrow.classList.remove('hidden');
                } else {
                    if (nextArrow.classList.contains('hidden')) nextArrow.classList.remove('hidden');
                    if (prevArrow.classList.contains('hidden')) prevArrow.classList.remove('hidden');
                }
            },

            arrowOffset: function() {
                if (isMobile) {
                    if (nextArrow.classList.contains('overflow')) nextArrow.classList.remove('overflow');
                } else {
                    var slide = eeCarousel.querySelectorAll('.slide')[slideIndex];

                    if (slide.scrollHeight > slide.offsetHeight && slide.offsetWidth > slide.scrollWidth) {
                        if (!nextArrow.classList.contains('overflow')) nextArrow.classList.add('overflow');
                    } else {
                        if (nextArrow.classList.contains('overflow')) nextArrow.classList.remove('overflow');
                    }
                }
            },

            change: function(uuid) {
                eEdition.menu.update(uuid);
                eEdition.pageview.navigation.update(uuid);
            },

            navigate: function(uuid, direction) {
                eEdition.pageview.carousel.navigate(uuid, direction);
                eEdition.pageview.navigation.change(uuid);
                eEdition.utilities.addHistory(eeData[uuid].url);
                d.title = eeData[uuid].metaTitle;
                eEdition.utilities.virtualPageview(uuid);
            },

            update: function(uuid) {
                var indexPages = [];

                Object.keys(eeData).forEach(function(page) {
                    if (eeData[page].slideIndex === slideIndex) indexPages.push(page);
                });

                eeUuid = uuid;
                nextArrow.dataset.eeditionUuid = eeData[indexPages[indexPages.length - 1]].next;
                prevArrow.dataset.eeditionUuid = eeData[indexPages[0]].prev;
                eEdition.pageview.navigation.arrowDisplay();
            }
        }
    };

    eEdition.subscription = {
        hasServices: function() {
            if (eeStage.classList.contains('subscriber-only')) return true;
            return false;
        }
    };

    eEdition.textview = {
        navigation: {
            _init: function() {
                eEdition.textview.navigation.arrowDisplay();
                eEdition.textview.navigation.arrowOffset();
            },

            arrowDisplay: function() {
                var articleUuids = Object.keys(eeData),
                    prevUrl,
                    nextUrl;

                // make sure this works for eeditions with 1 segmented article
                for (var i=0; i < articleUuids.length; i++) {
                    if (articleUuids[i] === eeUuid) {
                        if (i === 0) {
                            prevUrl = eeData[articleUuids[articleUuids.length - 1]].url;
                        } else {
                            prevUrl = eeData[articleUuids[i-1]].url;
                        }

                        if (i === articleUuids.length - 1) {
                            nextUrl = eeData[articleUuids[0]].url;
                        } else {
                            nextUrl = eeData[articleUuids[i+1]].url;
                        }
                        break;
                    }
                }

                if (nextArrow.classList.contains('hidden')) nextArrow.classList.remove('hidden');
                if (prevArrow.classList.contains('hidden')) prevArrow.classList.remove('hidden');

                nextArrow.href = nextUrl + '?view=text';
                prevArrow.href = prevUrl + '?view=text';

                nextArrow.style['z-index'] = '2';
                prevArrow.style['z-index'] = '2';
            },

            arrowOffset: function() {
                if (isMobile) {
                    if (nextArrow.classList.contains('overflow')) nextArrow.classList.remove('overflow');
                } else {
                    var toc = d.getElementById('eedition-toc');

                    if (toc.scrollHeight > toc.offsetHeight && toc.offsetWidth > toc.scrollWidth) {
                        if (!nextArrow.classList.contains('overflow')) nextArrow.classList.add('overflow');
                    } else {
                        if (nextArrow.classList.contains('overflow')) nextArrow.classList.remove('overflow');
                    }
                }
            }
        },

        print: {
            _init: function() {
                var printHold = false;
                d.getElementById('eedition-segment-container').querySelector('.segment-social-print').addEventListener('click', function(e){
                    if (printHold === false) {
                        e.preventDefault();
                        var printDivId = this.dataset.printAsset;

                        d.querySelectorAll(printDivId + ' .segment-images, ' + printDivId + ' .eedition-carousel').forEach(function(image){
                            $(image).trigger('appear');
                        });
                        setTimeout(function(){
                            $(printDivId).print({
                                globalStyles: true,
                                timeout: 500
                            });
                        }, 1250);
                        printHold = true;
                    } else {
                        return false;
                    }

                    setTimeout(function(){
                        printHold = false;
                    }, 1000);
                });
            }
        },

        thumbnail: {
            setup: function() {
                var thumbnail = d.getElementById('eedition-thumbnail'),
                    anchor = d.createElement('a'),
                    img = d.createElement('img');
                anchor.href = eeData[eeUuid].url;
                img.classList.add('img-responsive');
                img.src = eeData[eeUuid].image;
                thumbnail.appendChild(anchor);
                anchor.appendChild(img);
            }
        },

        toc: {
            getActiveAsset: function() {
                var segment = d.getElementById('eedition-segment-container').querySelector('.segment-article'),
                    segmentUuid = JSON.parse(segment.dataset.segmenting).uuid,
                    tocAssets = d.getElementById('eedition-toc').querySelectorAll('.entry');

                for (var i=0; i < tocAssets.length; i++) {
                    if (tocAssets[i].dataset.uuid == segmentUuid) {
                        tocAssets[i].classList.add('active');
                        tocAssets[i].scrollIntoView({behavior:'smooth', block:'center'});
                        break;
                    }
                }
            }
        }
    };

    eEdition.utilities = {
        addHistory: function(url) {
            history.pushState(null, '', url);
        },

        assetData: function() {
            var dataElement = d.getElementById('eedition-data'),
                hasDataAttr = false;
            if (dataElement && dataElement.dataset.eeditionUuid) hasDataAttr = true;

            if (hasDataAttr) {
                eeData = JSON.parse(dataElement.innerHTML);
                eeUuid = dataElement.dataset.eeditionUuid;
                eeHighlight = dataElement.dataset.highlight;
            }
            return hasDataAttr;
        },

        gtmDownloadEvent: function(label, link_text, link_url) {
            window.dispatchEvent(new CustomEvent('BLOXFileDownload', {
                detail: {
                    action: 'pdfDownload',
                    category: 'e-edition',
                    label: label,
                    link_text: link_text,
                    link_url: link_url
                }
            }));
        },

        minimumZoomLevel: function() {
            var stageHeight = w.innerHeight - 52,
                min = 350,
                max = 1950,
                step = 100,
                steps = 16;

            for (var i = 0; i < steps; i++) {
                if (stageHeight > max && max >= min) {
                    break;
                } else {
                    if (max > min) {
                        max = max - step;
                    } else {
                        break;
                    }
                }
            }
            return max;
        },

        virtualPageview: function(uuid) {
            var trackObject = {
                title: eeData[uuid].title,
                url: eeData[uuid].url,
                uuid: uuid,
                app: 'eedition',
                metric: ''
            };

            __tnt.trackEvent(trackObject);
        }
    };

    (d.readyState == 'loading') ? d.addEventListener('DOMContentLoaded', eEdition.app._init, false) : eEdition.app._init();

})(window, document, __tnt);